import { render, staticRenderFns } from "./DinnerChannelSource.vue?vue&type=template&id=00f65f28&scoped=true&"
import script from "./DinnerChannelSource.vue?vue&type=script&lang=js&"
export * from "./DinnerChannelSource.vue?vue&type=script&lang=js&"
import style0 from "./DinnerChannelSource.vue?vue&type=style&index=0&id=00f65f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f65f28",
  null
  
)

export default component.exports